/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Portal panel=add: URL'de ?panel=add varsa onAdd callback'ini tetikler.
 * Firma ekle, Organizasyon ekle vb. portal aksiyonları tıklandığında
 * iframe içindeki sayfa yüklenirken ekleme modalını otomatik açar.
 *
 * @param onAdd - Ekleme modalını açan fonksiyon (page.openModal veya openCreateModal)
 * @param canAdd - Yetki kontrolü (örn. canCreate('company'))
 */
export function usePanelAddTrigger(onAdd: () => void | Promise<void>, canAdd: boolean): void {
  const [searchParams] = useSearchParams();
  const onAddRef = useRef(onAdd);
  onAddRef.current = onAdd;

  useEffect(() => {
    if (searchParams.get('panel') === 'add' && canAdd) {
      void Promise.resolve(onAddRef.current());
    }
  }, [searchParams.get('panel'), canAdd]);
}
